import { RotateCcw, X } from "lucide-react";
import type { QueuedChatMessage } from "@/hooks/ai-chat/useAiChatMessageQueue";
import { Button } from "@/components/ui/shadcn/Button/Button";

/** Only actionable delays belong beneath an optimistic message bubble. */
export function ChatQueuedMessageStatus({
  message,
  onRetry,
  onRemove,
}: {
  message: QueuedChatMessage;
  onRetry?: (id: string) => void;
  onRemove?: (id: string) => void;
}) {
  if (message.status !== "error") return null;
  return (
    <div className="text-muted-foreground mt-2 flex items-center justify-end gap-2 text-xs">
      <span role="alert" className="text-destructive">
        {message.error}
      </span>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-7"
        aria-label="Retry message"
        onClick={() => onRetry?.(message.id)}
      >
        <RotateCcw className="size-3" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-7"
        aria-label="Remove queued message"
        onClick={() => onRemove?.(message.id)}
      >
        <X className="size-3" />
      </Button>
    </div>
  );
}
